const PRIVILEGES = {
  CREATE: 'Insert',
  UPDATE: 'Update',
  DELETE: 'Delete',
};

export {
  PRIVILEGES,
}
